import { toast } from 'react-toastify';
import { upload } from 'src/helpers/upLoadHelper';

export interface MessageRecipient {
  id: string | null;
  error?: string;
}

export interface ChatInput {
  message: string;
  image?: File[];
}

export interface BuildAndPostMessageOptions {
  chat: ChatInput;
  user: any;
  recipient: MessageRecipient;
  referenceId: string;
  referenceType: 'Ticket' | 'Suite';
  actionUrl: string;
  extraFields?: Record<string, any>;
  postMessageToAPI: (data: any) => Promise<void>;
}

const extractFileNameFromUrl = (url: string): string => {
  const parts: string[] = url.split('.com/');
  return parts.length > 1 ? parts[1] : '';
};

export const buildAndPostMessage = async ({
  chat,
  user,
  recipient,
  referenceId,
  referenceType,
  actionUrl,
  extraFields,
  postMessageToAPI,
}: BuildAndPostMessageOptions): Promise<void> => {
  if (!recipient.id) {
    toast.error(recipient.error || 'Unable to send message.', {
      autoClose: 5000,
      position: 'top-center',
    });

    return;
  }

  try {
    let imageUrl: string | null = null;

    if (chat.image && chat.image.length > 0) {
      imageUrl = (await upload(chat.image[0])) ?? null;
    }

    const fileName: string = imageUrl ? extractFileNameFromUrl(imageUrl) : '';

    const messageData: Record<string, any> = {
      SentBy: user.id,
      SentTo: recipient.id,
      ReferenceId: referenceId,
      ReferenceType: referenceType,
      Message: chat.message,
      FileName: fileName,
      FileURL: imageUrl,
      ActionUrl: actionUrl,
      ...(extraFields ?? {}),
    };

    await postMessageToAPI(messageData);
  } catch (error) {
    console.error('Error posting message:', error);
    toast.error('Failed to send message. Please try again.', {
      autoClose: 5000,
      position: 'top-center',
    });
  }
};
